// React & Libraries
import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Edit } from "react-feather";
import { Btn, H3, P } from "../../../../../../AbstractElements";

// Forms
import UpdateCityForm from "./UpdateCityForm";

interface UpdateregionModalProps {
  id: number;
}
const UpdateCityModal = ({ id }: UpdateregionModalProps) => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <Btn
        size="sm"
        color="primary"
        className="px-2"
        onClick={toggle}
        style={{ width: "105px" }}
      >
        {" "}
        <Edit size={11} /> Update
      </Btn>

      <Modal
        size="md"
        isOpen={modal}
        toggle={toggle}
        backdrop="static"
        keyboard={false}
      >
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Update City Record</H3>
            <button onClick={toggle} className="btn-close"></button>
            <P className="mb-0">
              Update the City/Municipality record to keep employee and applicant
              personal information accurate and up to date.
            </P>
          </ModalHeader>

          <UpdateCityForm toggle={toggle} id={id} />
        </div>
      </Modal>
    </>
  );
};

export default UpdateCityModal;
